import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import {
  MsalBroadcastService,
  MsalGuard,
  MsalModule,
  MsalService,
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
} from '@azure/msal-angular';
import { MSALGuardConfigFactory, MSALInstanceFactory, MSALInterceptorConfigFactory } from './msal.factory';
import { PortalMsalInterceptor } from './portal-msal.interceptor';

@NgModule({
  declarations: [],
  imports: [MsalModule],
  providers: [],
})
export class MsalConfigModule {
  static forRoot() {
    return {
      ngModule: MsalConfigModule,
      providers: [
        {
          provide: APP_INITIALIZER,
          useFactory: initializeMsalInstance,
          deps: [MsalService],
          multi: true,
        },
        {
          provide: MSAL_INSTANCE,
          useFactory: MSALInstanceFactory,
        },
        {
          provide: MSAL_GUARD_CONFIG,
          useFactory: MSALGuardConfigFactory,
        },
        {
          provide: MSAL_INTERCEPTOR_CONFIG,
          useFactory: MSALInterceptorConfigFactory,
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: PortalMsalInterceptor,
          multi: true,
        },
      ],
    };
  }
}

export function initializeMsalInstance(msalService: MsalService): () => Promise<void> {
  return async () => {
    try {
      await msalService.instance.initialize();
    } catch (error) {
      console.error('MSAL initialization failed:', error);
      throw error;
    }
  };
}
